import moment from 'moment';
import Vue from 'vue';

const CUSTOM_LOCALE = 'es-PR';

Vue.filter('empty', (value) => {
  return value || '-';
});

Vue.filter('formatDate', (value, format = null) => {
  const dateDefaultValues = ['0001-01-01T00:00:00', '0001-01-01T00:00:00Z'];
  if (value && !dateDefaultValues.includes(value)) {
    return moment(value)
      .locale('es-PR')
      .format(format == null ? 'DD/MMM/YYYY' : format);
  }
});

Vue.filter('maskSSN', (value) => {
  if (value) {
    return value.replace(new RegExp('.{5}(?=.{4}$)'), '***-**-');
  }
  return '-';
});

Vue.filter('unmaskSSN', (value) => {
  if (!value) return '-';

  let part1 = value.slice(0, 3);

  if (part1?.length === 3) part1 = part1 + '-';

  let part2 = value.slice(3, 5);

  if (part2?.length === 2) part2 = part2 + '-';

  return part1 + part2 + value.slice(5, 9);
});

Vue.filter('studentSie', (value) => {
  value = value || '';
  return `${value.replace(/[0-9]/gi, '')} - ${value.replace(
    /[a-z A-Z À-ú]/gi,
    ''
  )}`;
});

export const age = (val) => {
  if (!val) return null;
  return `${val}`.split('.')[0];
};

Vue.filter('age', age);

export default () => {
  Vue.prototype.$groupBy = (xs, f) => {
    return xs.reduce(
      (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
      {}
    );
  };

  Vue.prototype.$deleteArrayDuplicates = (array, filterId) => {
    let result = [];

    for (let i = 0; i < array.length; i++)
      if (!result.some((x) => x[filterId] == array[i][filterId])) {
        result.push(array[i]);
      }

    return result;
  };
};

export const phone = (value) => {
  if (value == undefined || value == '') return '-';

  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const studentSie = (value) => {
  value = value || '';
  return `${value.replace(/[0-9]/gi, '')} - ${value.replace(
    /[a-z A-Z À-ú]/gi,
    ''
  )}`;
};

export const price = (value, symbol = true) => {
  if (isNaN(+value)) return '';

  let val = (value / 1).toFixed(2);

  const result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return symbol ? '$' + result : result;
};

export const currency = (value) => {
  if (value == undefined || value == '' || value === null) return '-';

  return value.toLocaleString('en-US', { minimumFractionDigits: 2 });
};

export const ssn = (value) => {
  if (value === undefined || value === '' || value === null) return '';

  const lastDigits = value.substr(-4);
  return `xxx-xx-${lastDigits}`;
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const daywithnumber = (value) => {
  if (!value) return '';
  value = value.toString();

  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD - dddd')
    .replace(/ 0(?:0)?/, ' ')
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};
export const empty = (value) => {
  if (value == undefined || value == '') return '-';
  return value;
};
export const date = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY')
    .replace(/ 0(?:0)?/, ' ');

  return result;
};

export const dateTime = (value) => {
  if (!value) return '-';

  return `${date(value)} ${hour(value)}`;
};

export const hour = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('hh:mm A');

  return result;
};

export const time = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('hh:mm:ss a');

  return result;
};

export const appointmentFormat = (value) => {
  if (value == undefined || value == '') return '-';

  return value.replace(/[^0-9]/g, '').replace(/(\d{4})(\d{6})/, '$1-$2');
};

export const thousandsSeparator = (value) => {
  if (value === undefined || value === '') return '-';
  return value.toLocaleString('en-US', { minimumFractionDigits: 0 });
};
